import { AVAILABILITY_CHOICE } from "@Utils/constants/event";
import { LISTING_TYPES } from "repoV2/constants/listing";
import { useEventDataOfSelectedEvent } from "@Utils/event";
import { IScheduleSelectorTitleProps } from "./IScheduleSelectorTitle";

const useScheduleSelectorTitle = (props: IScheduleSelectorTitleProps) => {
    const { componentRef, disablePayment } = props;

    const { eventData } = useEventDataOfSelectedEvent();
    const {
        type: eventType,
        availability_choice: availabilityChoice,
        slots,
        metadata: eventMetadata,
    } = eventData;

    const {
        sessions_visible_on_booking_page: sessionsLimit,
        limit_sessions: isLimitSessionsEnabled,
    } = eventMetadata;

    const showDefaultSession =
        (isLimitSessionsEnabled && sessionsLimit === 1) || slots?.length === 1;

    // Slots Title
    let title = null;
    if (!disablePayment) {
        switch (eventType) {
            case LISTING_TYPES.APPOINTMENTS:
                if (availabilityChoice !== AVAILABILITY_CHOICE.NOT_DECIDED) {
                    title = "Schedule (Multiple Slots)";
                }
                break;
            case LISTING_TYPES.MERCHANDISE:
                title = "Select Quantity";
                break;
            case LISTING_TYPES.WORKSHOPS:
                title = "Schedule";
                break;
            case LISTING_TYPES.WEBINAR:
                title = "Select a Session";
                if (showDefaultSession) title = "Schedule";
                break;
            default:
                title = "Select a Schedule";
                break;
        }
    }

    return {
        title,
        componentRef,
        hideComponent:
            // since workshop schedule is shown as textual details, we hide it in case of `eventMetadata.hide_creator_detail`
            // but we still want to execute the business logic so that slots are sent in payment payload
            eventType === LISTING_TYPES.WORKSHOPS &&
            eventMetadata.hide_creator_detail,
    };
};

export default useScheduleSelectorTitle;
